export default __webpack_public_path__ + "static/src/companys/eif/assets/images/backgrounds/login_bg.png";